import script from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=c1873c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1873c88"]])

export default __exports__